import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { Contest } from 'src/app/models/contest';
import { Question } from 'src/app/models/question';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ContestService } from 'src/app/services/contest.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-get-bills',
  templateUrl: './get-bills.component.html',
  styleUrls: ['./get-bills.component.scss'],
})
export class GetBillsComponent implements OnInit {

  @Input() contests: Array<Contest> = [];

  @Output() onRequestBills: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  requestBillsQuestions: Array<Question> = [];
  loading: boolean = false;
  captcha: string = '';

  constructor(private contestService: ContestService, private tools: ToolsService, private alertCtrl: AlertController, private authSvc: AuthService,
    public configService: ConfigService, private recaptchaV3Service: ReCaptchaV3Service) {
  }

  ngOnInit() {
    this.loadQuestions();
    this.validateCaptcha();
  }

  loadQuestions() {
    // Init contest options
    let contestOptions: Array<any> = [];
    const documentTypeOptions = this.configService.getUserDocumentTypeOptions();
    this.contests.forEach((contest) => {
      contestOptions.push({
        id: contest.id,
        label: contest.name,
        value: contest.id
      });
    });

    // console.debug('Contest options', contestOptions);

    this.requestBillsQuestions = [
      {
        id: 'document-type',
        label: 'Tipo de documento *',
        type: 'select',
        incremental_info: false,
        options: documentTypeOptions,
        formControl: new FormControl(
          this.configService.getDefaultUserDocumentType(),
          [Validators.required]
        )
      }, {
        id: 'document',
        label: 'Documento *',
        type: 'text',
        formControl: new FormControl('', [Validators.required])
      },
      // {
      //   id: 'contest',
      //   label: 'Concurso *',
      //   type: 'select',
      //   incremental_info: false,
      //   options: contestOptions,
      //   formControl: new FormControl('', [Validators.required])
      // }
    ];
  }

  requestBills() {
    let hasError: boolean = false;
    for (let question of this.requestBillsQuestions) {
      if (question.formControl.invalid) {
        question.formControl.markAsTouched();
        hasError = true;
      }
    }
    if (hasError) return;

    this.loading = true;

    this.authSvc.login(
      this.tools.getValueFromLoginQuestion('document-type', this.requestBillsQuestions),
      this.tools.getValueFromLoginQuestion('document', this.requestBillsQuestions),
      this.captcha
    ).pipe(
      switchMap((lite_token: { refresh_token: string; access_token: string }) => {
        this.authSvc.setToken(lite_token.refresh_token);
        this.authSvc.saveLiteToken(lite_token.access_token);
        return this.contestService.sendResumeBills();
      })
    ).subscribe({
      next: (data) => {
        this.showAlertBills(data.message);
        this.requestBillsQuestions = [];
        this.loadQuestions();
        this.onRequestBills.emit(data);
      },
      error: (err) => {
        console.debug(err);
        this.loading = false;
        if (err.status == 404) {
          this.showAlertBills(err.error.message);
        } else if (err.status == 409) {
          this.tools.presentErrorToast('El documento es inválido');
        } else if (err.status == 401) {
          this.tools.presentErrorToast('Parece que este usuario no existe en el sistema, por favor revisa los datos');
        } else if (err.status == 400) {
          this.tools.presentErrorToast('Ocurrió un error, por favor recarga la página o intenta de nuevo más tarde');
        } else {
          this.tools.presentErrorToast('Ocurrió un error inesperado, intenta de nuevo más tarde');
        }
      },
      complete: () => {
        // console.debug('Proceso completo');
        this.loading = false;
      }
    });
  }


  async showAlertBills(message: string) {
    const alert = await this.alertCtrl.create({
      header: 'Tus Facturas',
      message: 'Hemos enviado el resumen de tus facturas al correo registrado. Por favor, revisa tu bandeja de entrada.',
      buttons: ['OK'],
    });
    return await alert.present();
  }


  goBack() {
    this.onBack.emit();
  }

  validateCaptcha(action = 'login') {
    if (this.configService.mall?.captcha_token) {
      this.recaptchaV3Service.execute(action).subscribe((token: string) => {
        this.captcha = token;
      });
    }
  }

}
